import { AccountCircleOutlined } from "@mui/icons-material";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";
import theme from "theme";
import { ManagementCard } from "routes/lenses/lens/admin/management/ManagementCard";
import LensProfileImportDialog from "../../profileimport/LensProfileImportDialog";

export default function ImportToProfile() {
  const { lensProfileQuestionImport } = useFlags();
  const [showImportToProfile, setShowImportToProfile] = useState<boolean>(false);

  if (lensProfileQuestionImport) {
    return (
      <>
        <ManagementCard
          id="lens-admin-management-import-profile"
          title="Profile Import"
          onClick={() => setShowImportToProfile(true)}
          Icon={AccountCircleOutlined}
          color={theme.palette.tertiary.main}
        />
        {showImportToProfile && <LensProfileImportDialog onClose={() => setShowImportToProfile(false)} />}
      </>
    );
  } else {
    return <></>;
  }
}
